
import { Spanish } from "../_Translate/Spanish";
import { English } from "../_Translate/English";

export const HAS__MODULE_RESOURCE_API = false;

const TRANSLATE = { es: Spanish, en: English };

export const onModuleContent = (lang = "es") => (TRANSLATE[lang] ?? Spanish).MODULE;

export const MODULE_CONTENT = onModuleContent();
